import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Statement.List.IRequest;
type Response = Api.Core.Statement.List.IResponse;
type Headers = Api.Core.Statement.List.IHeaders;
const url = '/api/DealerManagement/Statement';
export default async function statementListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
